<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <app-ibase-cru-modal-content [showDefaultFormFooter]="true" [contentClasses]="['floatingLabelContainer']">
        <p-floatlabel variant="on">
            <input id="name" type="text" pInputText formControlName="name" />
            <label for="name">Name</label>
        </p-floatlabel>

        <p-floatlabel variant="on">
            <input id="openid_connect_url" pInputText formControlName="openid_connect_url" />
            <label for="openid_connect_url">OpenID connect URL</label>
        </p-floatlabel>

        <p-floatlabel variant="on">
            <input id="frontend_url" pInputText formControlName="frontend_url" />
            <label for="frontend_url">Frontend URL</label>
        </p-floatlabel>

        <p-floatlabel variant="on">
            <input id="backend_url" pInputText formControlName="backend_url" />
            <label for="backend_url">Backend URL</label>
        </p-floatlabel>

        <p-floatlabel variant="on">
            <input id="client_id" pInputText formControlName="client_id" />
            <label for="client_id">Client ID</label>
        </p-floatlabel>

        <p-floatlabel variant="on">
            <p-password
                [toggleMask]="true"
                formControlName="client_secret"
                pTooltip="Enter the OO8 Connector M2M token"
                id="client_secret"
                [feedback]="false"
                autocomplete="current-password"
            ></p-password>
            <label for="client_secret">Client secret</label>
        </p-floatlabel>

        <p-floatlabel variant="on">
            <p-select
                id="verify_ssl"
                formControlName="verify_ssl"
                [autoDisplayFirst]="false"
                [options]="_booleanOptions"
                optionLabel="label"
                optionValue="value"
                appendTo="body"
                [disabled]="!isCreationMode"
            ></p-select>
            <label for="verify_ssl">Verify SSL?</label>
        </p-floatlabel>
    </app-ibase-cru-modal-content>
</form>
